import { useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./DetailPageCouponModal.gql";
import { useState } from "react";

export const useDetailPageCouponModal = (productSku) => {
  const [visibleCoupons, setVisibleCoupons] = useState(2);
  const [buttonText, setButtonText] = useState("View More Coupons");
  const { getAvailableCoupons } = DEFAULT_OPERATIONS;
  const { data } = useQuery(getAvailableCoupons, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    variables: {
      sku: productSku,
    },
    context: { fetchOptions: { method: "GET" } },
  });

  const toggleCoupons = () => {
    if (visibleCoupons === 2) {
      setVisibleCoupons(availableCoupons.length);
      setButtonText("View Less Coupons");
    } else {
      setVisibleCoupons(2);
      setButtonText("View More Coupons");
    }
  };

  const availableCoupons =
    data && data.AvailableCoupons ? data.AvailableCoupons : "";
  return {
    availableCoupons,
    toggleCoupons,
    buttonText,
    visibleCoupons,
  };
};
